import { put, takeEvery } from "redux-saga/effects";
import { fetchMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  FOLLOWER_COACH_STATE_START: "FOLLOWER_COACH_STATE_START",
  FOLLOWER_COACH_STATE_SUCCESS: "FOLLOWER_COACH_STATE_SUCCESS",
  FOLLOWER_COACH_STATE_FAILED: "FOLLOWER_COACH_STATE_FAILED"
};

// ============================================ Actions ========================================================

export const followerCoachStateStart = data => ({
  type: actionType.FOLLOWER_COACH_STATE_START,
  payload: data
});

export const followerCoachStateSuccess = data => ({
  type: actionType.FOLLOWER_COACH_STATE_SUCCESS,
  payload: data
});

export const followerCoachStateFailed = data => ({
  type: actionType.FOLLOWER_COACH_STATE_FAILED,
  payload: data
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null
};

export default function follwerCoachStateReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.FOLLOWER_COACH_STATE_START:
      return {
        ...state,
        loading: true
      };

    case actionType.FOLLOWER_COACH_STATE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };
    case actionType.FOLLOWER_COACH_STATE_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* followerCoachStateSaga(action) {
  try {
    const response = yield fetchMethod(`/api/useracivities/coachfollowersByState`,action.payload.variables,'post',true);
    if (response && response.status === 200) {
      yield put(
        followerCoachStateSuccess({data: response.data.response.data})
      );
    } else {
      messagePopup("", "Follower Coach Api failed", "error");
      yield put(followerCoachStateFailed("Follower Coach Api failed"));
    }
  } catch (error) {
    messagePopup("", "Follower Coach Api failed", "error");
    yield put(followerCoachStateFailed("Follower Coach Api failed"));
  }
}

export function* watchFollowerCoachStateSaga() {
  yield takeEvery(actionType.FOLLOWER_COACH_STATE_START, followerCoachStateSaga);
}
